import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { bindAll } from '@bibliocommons/utils-react';
import { shelfItemShape } from '@bibliocommons/bc-prop-types';

import { trackContentCollectionMove } from 'app/actions/AnalyticsGa4Actions';
import ShelfActions from 'app/actions/ShelfActions';
import { selectShelvesForCurrentUser } from 'app/selectors/ShelfSelector';
import AddedToShelfWorkflow from './AddedToShelfWorkflow';

export class AddedToShelfWorkflowContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  trackContentCollectionMove({ bibId, newShelf, privateItem, itemPosition, itemPositionGrouped, totalCount }) {
    const isFromSearchPage = window?.location?.pathname === '/v2/search';
    const properties = {
      content_collection_type: `shelf_${newShelf}`,
      privacy_status: privateItem ? 'private' : 'public'
    };
    const ui = isFromSearchPage
      ? {
          ui_content_position: itemPosition,
          ui_content_position_grouped: itemPositionGrouped,
          ui_content_position_grouped_count: totalCount
        }
      : null;
    this.props.trackContentCollectionMove({ bibId, properties, ui });
  }

  render() {
    const {
      id,
      itemPosition,
      itemPositionGrouped,
      totalCount,
      bib,
      shelfItem,
      closeWorkflow,
      shelfActions,
      view
    } = this.props;

    return (
      shelfItem && (
        <AddedToShelfWorkflow
          workflowId={id}
          bib={bib}
          itemPosition={itemPosition}
          itemPositionGrouped={itemPositionGrouped}
          totalCount={totalCount}
          shelfItem={shelfItem}
          handleClose={closeWorkflow}
          updateShelfItems={shelfActions.updateShelfItems}
          removeShelfItems={shelfActions.removeShelfItems}
          view={view}
          trackContentCollectionMove={this.trackContentCollectionMove}
        />
      )
    );
  }
}

AddedToShelfWorkflowContainer.propTypes = {
  id: PropTypes.string,
  itemPosition: PropTypes.number,
  itemPositionGrouped: PropTypes.number,
  totalCount: PropTypes.number,
  bib: ImmutablePropTypes.map,
  shelfItem: shelfItemShape,
  closeWorkflow: PropTypes.func.isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired,
  view: PropTypes.string,
  trackContentCollectionMove: PropTypes.func
};

AddedToShelfWorkflowContainer.displayName = 'ItemTransactionWorkflowContainer';

const mapStateToProps = (state, ownProps) => {
  const bib = state.getIn(['entities', 'bibs', ownProps.metadataId, 'briefInfo']);
  const shelfItem = selectShelvesForCurrentUser(state).get(ownProps.metadataId);

  return {
    bib,
    shelfItem
  };
};

const mapDispatchToProps = dispatch => ({
  shelfActions: bindActionCreators(ShelfActions, dispatch),
  trackContentCollectionMove: bindActionCreators(trackContentCollectionMove, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(AddedToShelfWorkflowContainer);
